/**
 * NotFoundScreen — the root route's `notFoundComponent` (PO finding 2026-10-05 #5: the
 * router has no not-found handling today; an unknown path fell through to TanStack
 * Router's bare default). An unmatched path like `/no-such-page` matches ONLY the root
 * route (no descendant route's path pattern fits it), so this renders OUTSIDE the
 * `_authenticated` layout — it reads the auth store directly and reconstructs the right
 * chrome itself: the app shell (`AppShell`) for a signed-in, firm-bound user; the public
 * auth card (`AuthCard`) otherwise (signed out, or signed in with no firm session bound).
 */
import type { JSX } from 'react';

import { AppShell } from '../components/app-shell.tsx';
import { AuthCard } from '../components/ui.tsx';
import { Button, EmptyState, LinkButton } from '../components/ui/index.ts';
import { useAuth } from '../store/auth-store.ts';

const TITLE = 'Page not found';
const DESCRIPTION = 'The address is wrong or the page moved.';

function Actions(): JSX.Element {
  return (
    <>
      <LinkButton to="/dashboard" variant="primary">
        Go to dashboard
      </LinkButton>
      <Button variant="ghost" onClick={() => window.history.back()}>
        Back
      </Button>
    </>
  );
}

export function NotFoundScreen(): JSX.Element {
  const status = useAuth((s) => s.status);
  const user = useAuth((s) => s.user);

  if (status === 'authenticated' && user !== null) {
    return (
      <AppShell>
        <div className="argus-page">
          <EmptyState title={TITLE} description={DESCRIPTION} action={<Actions />} />
        </div>
      </AppShell>
    );
  }

  return (
    <AuthCard title={TITLE} subtitle={DESCRIPTION}>
      <div className="row" style={{ gap: 12, flexWrap: 'wrap' }}>
        <Actions />
      </div>
    </AuthCard>
  );
}
